<template>   
   <HeaderDash />
   <SideMenu /> 
   <ContentScreenshot /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash'
import SideMenu from '@/components/team/dashboard/SideMenu'
import ContentScreenshot from '@/components/team/dashboard/modules/activity/screenshot/ContentScreenshot'
export default 
{
  name: 'Screenshot',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentScreenshot
  }
}
</script>

<style>


</style>
